import React, { useEffect, useState } from 'react';
import ModalComponent from './modalComponent';
import { Box, Stack, Typography } from '@mui/material';
import Lottie from 'lottie-react';
import serverError from "../../animations/serverError.json";

export default function ErrorModal({ open, handleClose, message, subMessage }) {
  const [animatingWar, setAnimatingWar] = useState(false);

  useEffect(() => {
    if (open) {
      setAnimatingWar(true);
    }
  }, [open]);

  return (
    <ModalComponent open={open} handleClose={handleClose}>
      <Box sx={{ textAlign: 'center', bgcolor: '#fdedec', borderRadius: 2, padding: "24px 12px" }}>
        <Stack
          sx={{
            alignItems: 'center',
            justifyContent: 'center',
            bgcolor: '#fdedec',
            borderRadius: 2,
            padding: 1,
            minWidth: { md: '600px' },
            mt: 2
          }}
        >
          {animatingWar && (
            <Box sx={{ width: 150, marginTop: "-35px" }}>
              <Lottie animationData={serverError} loop />
            </Box>
          )}

          <Typography variant='landingSubTitle' sx={{ textAlign: 'center', lineHeight: '35px' }}>
            {message}
            {subMessage && (
              <>
                <br />
                <span style={{ fontSize: '16px' }}>{subMessage}</span>
              </>
            )}
          </Typography>
        </Stack>
      </Box>
    </ModalComponent>
  );
}
